// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"329":"49128056","406":"87c24f05","453":"d855a71b","854":"3bff3b26"}[chunkId] + ".chunk.js";
};